import React, { useEffect, useId, useState } from "react";
import Header from "../../UserManagement/Components/Header";
import { FaBullseye, FaChartLine, FaDollarSign, FaUsers } from "react-icons/fa";
import KPICard from "./KPICard";
import ForecastingCard from "./ForecastingCard";
import { Col, Row } from "react-bootstrap";
import ThemeChart from "../../../Components/ThemeChart";
import { revenueChartData, revenueChartOptions } from "../../../constants";
import MainCard from "../../../Components/Cards/MainCard";
import RevenueChart from "../../../Components/RevenueChart";
import MRRGrowthChart from "../../../Components/MRRGrowthChart";
import PlatformFeeForm from "./PlatformFeeForm";
import EliteAgentForm from "./EliteAgentForm";
import PaymentGatewayIntegrationForm from "./PaymentGatewayIntegrationForm";
import TransactionOrderLog from "./TransactionOrderLog";
import ForecastingCardSkeleton from "../../../Components/Skeleton/ForecastingCardSkeleton";
import PlatformFeeFormSkeleton from "../../../Components/Skeleton/PlatFormSkeleton";
import ApiKeyFormSkeleton from "../../../Components/Skeleton/ApiKeyFormSkeleton";
import TransactionOrderLogSkeleton from "../../../Components/Skeleton/TransactionOrderLogSkeleton";

const forecastingCardConfig = {
  1: {
    iconColor: "text-success",
    icon: <FaDollarSign size={24} />,
  },
  2: {
    iconColor: "text-primary",
    icon: <FaChartLine size={24} />,
  },
  3: {
    iconColor: "text-purple",
    icon: <FaBullseye size={24} />,
  },
  4: {
    iconColor: "text-warning",
    icon: <FaUsers size={24} />,
  },
};

const transactionData = [
  {
    id: "#ORD-2025-001",
    type: "Elite Subscription",
    from: "John Agent",
    to: "Platform",
    amount: "$49.00",
    account: "Platform Account",
    status: "Completed",
    date: "Jan 15, 2025",
  },
  {
    id: "#ORD-2025-002",
    type: "Video Call",
    from: "Sarah Client",
    to: "Mike Agent",
    amount: "$75.00",
    account: "Escrow Account",
    status: "In Escrow",
    date: "Jan 14, 2025",
  },
  {
    id: "#ORD-2025-003",
    type: "Platform Fee",
    from: "Property Sale",
    to: "Platform",
    amount: "$2,500.00",
    account: "Platform Account",
    status: "Completed",
    date: "Jan 13, 2025",
  },
  {
    id: "#ORD-2025-004",
    type: "Custom Service",
    from: "Lisa Client",
    to: "David Agent",
    amount: "$150.00",
    account: "Escrow Account",
    status: "Pending",
    date: "Jan 12, 2025",
  },
  {
    id: "#ORD-2025-005",
    type: "Brokerage",
    from: "ABC Realty",
    to: "Platform",
    amount: "$99.00",
    account: "Platform Account",
    status: "Completed",
    date: "Jan 11, 2025",
  },
];

const ForecastingTab = ({ forecastingKPIs }) => {
  const uniqueId = useId();

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  return (
    <div>
      <div>
        <Header
          title={"Forecasting"}
          // subTitle={"Product revenue, platform fees, and commission tracking"}
        />
      </div>
      <br />
      <div>
        {/* Forecast KPI's */}
        <div className="d-flex flex-wrap gap-3">
          {dummyFetch.isFetching
            ? Array.from({ length: 4 }).map((_, index) => (
                <div
                  key={uniqueId + index}
                  style={{
                    flex: "1 1 250px",
                    // maxWidth: "300px"
                  }}
                >
                  <ForecastingCardSkeleton />
                </div>
              ))
            : forecastingKPIs.map((data) => (
                <div
                  key={data.id}
                  style={{
                    flex: "1 1 250px",
                    // maxWidth: "300px"
                  }}
                >
                  <ForecastingCard
                    kpiData={data}
                    cardConfig={forecastingCardConfig[data.id]}
                  />
                </div>
              ))}
        </div>
        <br />
        {/* Charts */}
        <Row className="gap-4 gap-md-0">
          <Col md={6} sm={12}>
            <MainCard>
              <h4 className="my-2 fw-bold mb-4">Revenue Forecast</h4>
              <RevenueChart
                loading={dummyFetch.isFetching}
                // data={revenueChartData}
                // options={revenueChartOptions}
              />
            </MainCard>
          </Col>
          <Col md={6} sm={12}>
            <MainCard>
              <h4 className="my-2 fw-bold mb-4">MRR Growth</h4>
              <MRRGrowthChart
                loading={dummyFetch.isFetching}
                // data={revenueChartData}
                // options={revenueChartOptions}
              />
            </MainCard>
          </Col>
        </Row>
        <br />
        {/* Forms */}
        <Row className="gap-4 gap-md-0">
          <Col md={6} sm={12}>
            <MainCard>
              <h4 className="my-2 fw-bold mb-4">Platform Fee Configuration</h4>
              {dummyFetch.isFetching ? (
                <PlatformFeeFormSkeleton />
              ) : (
                <PlatformFeeForm />
              )}
            </MainCard>
          </Col>
          <Col md={6} sm={12}>
            <MainCard>
              <h4 className="my-2 fw-bold mb-4">Elite Agent Subscription</h4>
              {dummyFetch.isFetching ? (
                <PlatformFeeFormSkeleton />
              ) : (
                <EliteAgentForm />
              )}
            </MainCard>
          </Col>
        </Row>
        <br />
        {dummyFetch.isFetching ? (
          <ApiKeyFormSkeleton />
        ) : (
          <PaymentGatewayIntegrationForm />
        )}
        <br />
        {dummyFetch.isFetching ? (
          <TransactionOrderLogSkeleton />
        ) : (
          <TransactionOrderLog data={transactionData} />
        )}
      </div>
    </div>
  );
};

export default ForecastingTab;
